var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01404 3.77331C6.68077 2.98903 5 3.95034 5 5.49718V18.5035C5 20.0503 6.68077 21.0117 8.01404 20.2274L19.0695 13.7242C20.384 12.9509 20.384 11.0498 19.0695 10.2765L8.01404 3.77331Z",
    fill: "#000F30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayAudio);
export default __webpack_public_path__ + "static/media/PlayAudio.4ee1c41ae77e1819b051d63d79070d87.svg";
export { ForwardRef as ReactComponent };